// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".region-notice[data-v-d596974c]{position:relative}.region-notice .region-notice__button-wrapper[data-v-d596974c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.region-notice .region-notice__save-button[data-v-d596974c]{display:block;margin-left:auto}", ""]);
// Exports
module.exports = exports;
